import React, { useEffect, useRef, useState } from "react";
import { selectFieldExtendedProps } from "../../interfaces";
import DropDown from "./dropDownMenu";
import { useDispatch, useSelector } from "react-redux";
import { pickListEngagmentDataPopup, resetPickEngagmentListData } from "../../views/case-summary/store/actions";
import useLegacySupport from "../hooks/useLegacySupported";
import { toast } from "react-toastify";

const DropDownExtended = (props:any) => {
    const dispatch = useDispatch();
    const lagacyToken = useLegacySupport();

    const item = props.item;
    const dspId = "";



    const [data, setData] = useState([])
    const [isChild, setIsChild] = useState<boolean>(false);

    const pickList = useSelector((state: any) => state.selectEngagmentPickCM);

    useEffect(() => {
        // Fetch Information pickList


        if (props.isChild === null || props.isChild === undefined) {
            fetchPickerData();
            debugger
        } else {
            const childData = props.isChild.find((element: any) => parseInt(element) === props.item.controlId);

            if (childData !== undefined) {
                setIsChild(true);
            } else {
                fetchPickerData();
                debugger
            }
        }
    }, []);

    useEffect(() => {
        if (pickList.isSuccess && pickList.data !== null && props.item.controlId === pickList.data.controlId) {
            setData(pickList.data.values);
            dispatch(resetPickEngagmentListData())
        } else if (pickList.isError) {
            dispatch(resetPickEngagmentListData())
        }
    }, [pickList, dispatch, props.item.controlId]);

    const fetchPickerData = () => {
        try {
            dispatch(
                pickListEngagmentDataPopup({
                    token: lagacyToken.token,
                    param: {
                        dspId: dspId,
                        parentPickListSelectedValue: '',
                        // parentPickListSelectedValue: props?.formData?.CommitmentPresentingNeed == undefined ? "" : props?.formData?.CommitmentPresentingNeed,
                        controlId: props.item.controlId,
                    },
                    url: props.item.apiPicklistEndpoint.endpointUrl.replace("/api", ""),
                })
            );

        } catch (e: any) {
            toast.error(e.message);
        }
    }

    return (<div>picker</div>);

    // return (<DropDownExtended
    //     // isChild={childPicklistControlIds}
    //     label={item.label}
    //     labelExternal={true}
    //     key={"toolbar"}
    //     name={item.name}
    //     // data={parseDataForDropDown(item.picklistValues)}
    //     item={item}
    //     defaultSelected={""}
    //     isMultiSelectPickList={item.isMultiSelectPickList}
    //     onChange={(e: any) => { }}
    // />)
};

export default DropDownExtended;